var map = {
	"./android-apk.svg": "f+CR",
	"./app-store.svg": "lPOO",
	"./exclusive-0.svg": "O+2j",
	"./exclusive-1.svg": "lw6O",
	"./exclusive-2.svg": "/wE7",
	"./exclusive-3.svg": "qWJf",
	"./exclusive-4.svg": "rQqh",
	"./exclusive-bg.svg": "Vkno",
	"./google-play.svg": "Wqbl",
	"./guide-1.svg": "oe/G",
	"./guide-2.svg": "jqom",
	"./guide-3.svg": "1AaN",
	"./guide-module-border.svg": "fdVb",
	"./intro-module-border.svg": "1dJV",
	"./line.svg": "9xjd",
	"./news-module-border.svg": "IR9V",
	"./notice-module-border.svg": "tDre",
	"./people.svg": "GPe0",
	"./presence-1.svg": "+1R/",
	"./presence-2.svg": "6kYO",
	"./presence-3.svg": "znMh",
	"./presence-4.svg": "yvAs",
	"./test-flight.svg": "UZ55",
	"./wallet.svg": "LnY7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 47